import { X } from 'lucide-react';

/**
 * Warnt, wenn im Feld "Steuer-Identifikationsnummer" vermutlich eine Steuernummer
 * (Finanzamt-/Gewerbesteuernummer) statt der persönlichen 11-stelligen IdNr. steht —
 * häufige Verwechslung bei Einzelunternehmer/innen im Onboarding. Nicht blockierend,
 * nur ein Hinweis (der Wert wird nicht automatisch geändert).
 */
export function SteuerIdWarnModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="relative bg-white dark:bg-slate-800 rounded-xl shadow-xl p-6 w-[min(90vw,440px)] text-left">
        <button type="button" onClick={onClose} aria-label="Schließen"
          className="absolute top-2.5 right-2.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200">
          <X className="w-5 h-5" />
        </button>
        <p className="text-lg font-semibold text-amber-700 dark:text-amber-400">Bitte prüfen: richtige Nummer?</p>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
          Diese Eingabe sieht nach einer <strong>Steuernummer vom Finanzamt</strong> aus
          (Format mit Schrägstrichen, z.&nbsp;B. „123/123/12345"), nicht nach der
          persönlichen <strong>Steuer-Identifikationsnummer (IdNr.)</strong>.
        </p>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
          Die IdNr. ist 11-stellig, besteht nur aus Ziffern (keine Schrägstriche) und steht
          auf dem Einkommensteuerbescheid, der Lohnsteuerbescheinigung oder im Schreiben vom
          Bundeszentralamt für Steuern.
        </p>
        <button type="button" onClick={onClose}
          className="mt-4 px-4 py-2 bg-purple-600 text-white rounded-lg text-sm font-medium">Verstanden</button>
      </div>
    </div>
  );
}
